import { IonBadge, IonFab, IonFabButton, IonIcon } from "@ionic/react";
import { chatbubbleEllipsesOutline } from "ionicons/icons";
import { useEffect, useMemo, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { listarConversaciones, obtenerPermisoChat } from "src/services/chat";

import "./ChatFloatingButton.css";

interface Props {
  isAuth: boolean;
  cargo?: string;
}

const habilitadoPilotoTI = (cargo?: string) => {
  const cargoNorm = String(cargo || "").toLowerCase();
  return (
    cargoNorm.includes("tic")
    || cargoNorm.includes("desarrollador")
    || cargoNorm.includes("gerente de tecnologias de la informacion")
  );
};

const ChatFloatingButton: React.FC<Props> = ({ isAuth, cargo }) => {
  const history = useHistory();
  const location = useLocation();
  const [noLeidos, setNoLeidos] = useState(0);
  const [chatHabilitado, setChatHabilitado] = useState(false);
  const [tabVisible, setTabVisible] = useState<boolean>(document.visibilityState === "visible");

  useEffect(() => {
    const onVisibilityChange = () => {
      setTabVisible(document.visibilityState === "visible");
    };

    document.addEventListener("visibilitychange", onVisibilityChange);
    return () => document.removeEventListener("visibilitychange", onVisibilityChange);
  }, []);

  useEffect(() => {
    let activo = true;

    const cargarPermiso = async () => {
      if (!isAuth) {
        if (!activo) return;
        setChatHabilitado(false);
        return;
      }
      try {
        const permiso = await obtenerPermisoChat();
        if (!activo) return;
        setChatHabilitado(Boolean(permiso?.habilitado));
      } catch {
        if (!activo) return;
        setChatHabilitado(habilitadoPilotoTI(cargo));
      }
    };

    cargarPermiso();

    return () => {
      activo = false;
    };
  }, [isAuth, cargo]);

  const visible = useMemo(() => {
    if (!isAuth) return false;
    if (!chatHabilitado) return false;
    if (location.pathname === "/login") return false;
    if (!location.pathname.startsWith("/home")) return false;
    return true;
  }, [isAuth, chatHabilitado, location.pathname]);

  useEffect(() => {
    let activo = true;
    let timer: any;

    const cargarNoLeidos = async () => {
      if (!visible || !tabVisible) return;
      try {
        const conversaciones = await listarConversaciones();
        if (!activo) return;
        const total = conversaciones.reduce((acc, cur) => acc + Number(cur.no_leidos || 0), 0);
        setNoLeidos(total);
      } catch {
        if (!activo) return;
        setNoLeidos(0);
      }
    };

    cargarNoLeidos();
  timer = setInterval(cargarNoLeidos, 20000);

    return () => {
      activo = false;
      if (timer) clearInterval(timer);
    };
  }, [visible, tabVisible]);

  if (!visible) return null;

  return (
    <IonFab vertical="bottom" horizontal="end" slot="fixed" className="chat-floating-fab">
      <IonFabButton color="primary" onClick={() => history.push("/mensajes")}> 
        <IonIcon icon={chatbubbleEllipsesOutline} />
        {noLeidos > 0 && (
          <IonBadge color="danger" className="chat-floating-badge">
            {noLeidos > 99 ? "99+" : noLeidos}
          </IonBadge>
        )}
      </IonFabButton>
    </IonFab>
  );
};

export default ChatFloatingButton;
